import { useCallback } from 'react';
import { BufferEventType, ComposerAnalyticsEvent, ComposerMode, } from '../types/index';
import { buildCreateEventPayload } from '../utils/payloadBuilders';
var DEFAULT_BUFFER_DURATION = 'PT15M';
export function useHandleEventCreation(_a) {
    var formData = _a.formData, timezone = _a.timezone, createEvent = _a.createEvent, calendarType = _a.calendarType, calendarMailboxAddress = _a.calendarMailboxAddress, requestOnlySpace = _a.requestOnlySpace, onSubmit = _a.onSubmit, onClose = _a.onClose, onTrackBufferEvent = _a.onTrackBufferEvent, onTrackComposerEvent = _a.onTrackComposerEvent;
    var handleEventCreation = useCallback(function () {
        var _a, _b;
        var payload = buildCreateEventPayload({
            formData: formData,
            timezone: timezone,
            calendarType: calendarType,
            calendarMailboxAddress: calendarMailboxAddress,
            requestOnlySpace: requestOnlySpace,
        });
        if (payload) {
            var hasBuffers_1 = (_a = formData.spaces) === null || _a === void 0 ? void 0 : _a.some(function (space) { var _a; return (_a = formData.spaceBuffers) === null || _a === void 0 ? void 0 : _a[space.id]; });
            var buffersChangedFromDefault_1 = (_b = formData.spaces) === null || _b === void 0 ? void 0 : _b.some(function (space) {
                var _a;
                var spaceBufferData = (_a = formData.spaceBuffers) === null || _a === void 0 ? void 0 : _a[space.id];
                if (!spaceBufferData)
                    return false;
                return ((spaceBufferData.beforeEvent &&
                    spaceBufferData.beforeEvent !== DEFAULT_BUFFER_DURATION) ||
                    (spaceBufferData.afterEvent &&
                        spaceBufferData.afterEvent !== DEFAULT_BUFFER_DURATION));
            });
            createEvent(payload)
                .then(function (res) {
                var _a, _b, _c, _d, _e, _f;
                if (!res) {
                    /* createEvent surfaced the error via its error state (retry modal) */
                    onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                        mode: ComposerMode.CREATE,
                    });
                    return;
                }
                onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_CREATED, {
                    spaceCount: (_b = (_a = formData.spaces) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
                    inviteeCount: (_d = (_c = formData.invitees) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0,
                    externalInviteeCount: (_f = (_e = formData.invitees) === null || _e === void 0 ? void 0 : _e.filter(function (invitee) { return invitee.user_id == null && invitee.email; }).length) !== null && _f !== void 0 ? _f : 0,
                    hasRecurrence: !!formData.recurrenceRule,
                    isRequestOnly: !!requestOnlySpace,
                });
                if (hasBuffers_1 && onTrackBufferEvent && formData.spaces) {
                    onTrackBufferEvent(BufferEventType.CREATED_BUFFER_EVENT, {
                        spaceCount: formData.spaces.length,
                        bufferSpaceCount: formData.spaces.filter(function (space) { var _a; return (_a = formData.spaceBuffers) === null || _a === void 0 ? void 0 : _a[space.id]; }).length,
                        buffersChangedFromDefault: buffersChangedFromDefault_1,
                    });
                }
                onSubmit(res.data, ComposerMode.CREATE);
                onClose();
            })
                .catch(function () {
                /* createEvent already calls onError before re-throwing; catch only to avoid unhandled rejection */
                onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                    mode: ComposerMode.CREATE,
                });
            });
        }
    }, [
        formData,
        timezone,
        createEvent,
        calendarType,
        calendarMailboxAddress,
        requestOnlySpace,
        onSubmit,
        onClose,
        onTrackBufferEvent,
        onTrackComposerEvent,
    ]);
    return { handleEventCreation: handleEventCreation };
}
